import React, { useEffect, useState } from 'react';
import { Logout, MenuItemLink, useAuthProvider, useCreatePath, UserMenu as UserMenuReactAdmin } from 'react-admin';
import { ReactComponent as ChevronDown } from 'src/assets/chevron-down.svg';
import './index.css';
import { UserRole, UserType } from '../../auth/types';
import { UserRoleLabel } from '../../constants';
import UnknownAvatar from '../common/UnknownAvatar';
import { Resource as ResourceName } from '../../constants/resources';
import WithRole from '../common/WithRole';
import { AllExceptAdminGroup } from 'src/constants/roles';
import { Theme } from 'src/Theme';

const Icon: React.FC<{ profile?: UserType }> = ({ profile }) => {
    return (
        <div className="user_menu_container">
            <UnknownAvatar lastName={profile?.surname || ''} firstName={profile?.name} size="medium" />
            <div className="user_menu_titles">
                <div className="user_menu__name">{profile?.surname + ' ' + profile?.name}</div>
                <div className="user_menu__role">
                    {profile?.authorities?.map((role) => UserRoleLabel[role] || '').join(', ')}
                </div>
            </div>
            <ChevronDown />
        </div>
    );
};

const UserMenu: React.FC = () => {
    const [profile, setProfile] = useState<UserType>();
    const { getIdentity } = useAuthProvider();
    const createPath = useCreatePath();

    useEffect(() => {
        getIdentity?.().then((profile) => {
            setProfile(profile as UserType);
        });
    }, [getIdentity]);

    return (
        <UserMenuReactAdmin className="user_menu__RA" icon={<Icon profile={profile} />}>
            <WithRole roles={AllExceptAdminGroup}>
                <MenuItemLink
                    to={createPath({ resource: ResourceName.PROFILE, type: 'show', id: profile?.id })}
                    primaryText="Мій профіль"
                    sx={{ color: Theme.palette.primary.midnightBlue }}
                />
            </WithRole>
            <Logout sx={{ color: Theme.palette.primary.midnightBlue }} />
        </UserMenuReactAdmin>
    );
};

export default UserMenu;
